
const formatInputName = (name, prefixer) => {
  return prefixer === null ? name : `${prefixer}[${name}]`;
};
const formatInputId = (name, prefixer) => `${prefixer}-${name}`;

export { formatInputName, formatInputId };
